import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '@/App';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { CheckCircle, Wrench, Sparkles } from 'lucide-react';
import axios from 'axios';
import { API } from '@/App';
import { toast } from 'sonner';

const Subscription = () => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const features = [
    'Smart CNC Calculator with material-specific parameters',
    'Step-by-step Troubleshooting Wizard',
    'Comprehensive Knowledge Base',
    'Community Chat Rooms',
    'Maker Marketplace access',
    'Machine & Tool Profile Management',
    'CAM-ready Tool Exports',
    'Priority Support'
  ];

  const handleSubscribe = async () => {
    setIsLoading(true);
    try {
      const origin_url = window.location.origin;
      // Lemon Squeezy integration pending (store activation)
      toast.error('Subscriptions are temporarily unavailable. Please check back shortly.');
      setIsLoading(false);
      return;
    } catch (error) {
      toast.error('Subscriptions are temporarily unavailable. Please check back shortly.');
      setIsLoading(false);
    }
  };

  return (
    <div data-testid="subscription-page" className="min-h-screen bg-[#0F172A] flex items-center justify-center p-4">
      <div className="max-w-2xl w-full">
        <div className="text-center mb-8">
          <div className="flex items-center justify-center gap-2 mb-4">
            <Wrench className="w-12 h-12 text-[#e67e22]" />
            <h1 className="text-4xl font-heading font-black tracking-tight text-[#e67e22]">
              CNC <span className="text-[#e67e22]">Helpdesk</span>
            </h1>
          </div>
          <div className="inline-flex items-center gap-2 bg-[#e67e22]/20 text-[#e67e22] px-4 py-2 rounded-full text-sm font-bold uppercase tracking-wide mb-4">
            <Sparkles className="w-4 h-4" />
            Early Access Offer
          </div>
        </div>

        <Card className="bg-[#1E293B] border-[#e67e22] border-2">
          <CardHeader className="text-center">
            <CardTitle className="text-3xl text-[#e67e22] mb-2">Unlock Full Access</CardTitle>
            <CardDescription className="text-zinc-400">
              Get 3 months of unlimited access to all premium features
            </CardDescription>
            <div className="mt-6">
              <div className="text-5xl font-black text-[#e67e22] mb-2">
                $12
              </div>
              <div className="text-sm text-zinc-400">One-time payment • 3 months access</div>
            </div>
          </CardHeader>
          <CardContent className="space-y-6">
            <div className="bg-[#0F172A] rounded-lg p-6 space-y-3">
              {features.map((feature, index) => (
                <div key={index} className="flex items-start gap-3">
                  <CheckCircle className="w-5 h-5 text-[#10B981] flex-shrink-0 mt-0.5" />
                  <span className="text-zinc-300">{feature}</span>
                </div>
              ))}
            </div>

            <Button
              data-testid="subscribe-btn"
              onClick={handleSubscribe}
              disabled={isLoading}
              className="w-full bg-[#F59E0B] hover:bg-[#F59E0B]/90 text-[#0F172A] font-bold uppercase tracking-wide py-6 text-lg"
            >
              {isLoading ? 'Processing...' : 'Get Early Access Now'}
            </Button>

            <div className="text-center text-xs text-zinc-500">
              <p>Payment portal coming soon (Lemon Squeezy)</p>
              <p className="mt-1">After 3 months, we will introduce tiered pricing options</p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default Subscription;
